import { makeAutoObservable } from 'mobx'
import { RootStore } from 'stores'
import { getEcnSuggestions } from 'API/ecnSuggestion'
import { IEcnSuggestionWithRelations } from 'interfaces/ecnSuggestion'

export default class EcnSuggestionStore {
  rootStore: RootStore

  ecnSuggestionsForBasicUser: IEcnSuggestionWithRelations[] = []
  ecnSuggestionsForAdmin: IEcnSuggestionWithRelations[] = []

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  public async fetchEcnSuggestions(stepId: number, forAdmin?: boolean) {
    const commonFilter = {
      order: ['createdAt ASC'],
      include: [{ relation: 'user' }, { relation: 'ecnSuggestionAttachments' }]
    }
    if (!forAdmin) {
      this.ecnSuggestionsForBasicUser = await getEcnSuggestions({
        where: { stepId, isAdminOnly: forAdmin },
        ...commonFilter
      })
      this.ecnSuggestionsForAdmin = []
    } else {
      const suggestions = await getEcnSuggestions({
        where: { stepId },
        ...commonFilter
      })
      this.ecnSuggestionsForBasicUser = suggestions.filter(suggestion => !suggestion?.isAdminOnly)
      this.ecnSuggestionsForAdmin = suggestions.filter(suggestion => suggestion?.isAdminOnly)
    }
  }
}
